<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitle"><a id="pxxv"></a>THE SORCERER’S APPRENTICE</p>
<p class="linespace"></p>
<p class="orna-bottom"><img alt="Zipes" src="images/ornament7.png"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter_opening.vue?d8a0e132